import { createRoute, redirect, useParams } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { useAdminProvider } from '../../../../hooks/useAdminProviders.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';
import { ProviderForm } from '../../../../components/admin/ProviderForm.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/providers/$providerId',
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role;
    if (role !== 'super_admin') throw redirect({ to: '/app' });
  },
  component: EditProviderPage,
});

function EditProviderPage() {
  const { providerId } = useParams({ from: '/app/admin/providers/$providerId' });
  const { data, isLoading, error } = useAdminProvider(providerId);

  if (isLoading) return <p className="text-muted">Loading…</p>;
  if (error)
    return (
      <p className="text-danger bg-danger-bg border border-danger/30 rounded-lg px-4 py-3">
        {(error as Error).message}
      </p>
    );
  if (!data) return null;

  return (
    <div>
      <AdminPageHeader
        title={data.provider.name}
        description="Edit this provider's master record. Changes are visible to every tenant who has access."
        backTo="/app/admin/providers"
        backLabel="All providers"
      />
      <ProviderForm initial={data.provider} />
    </div>
  );
}
